import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from 'ngx-webstorage';
import { MsalService } from '@azure/msal-angular';
import { GraphService } from 'src/app/services/graph.service';

import { PoOrderDataServiceService } from 'src/app/services/po-order-data-service.service';
import { ReportsService } from 'src/app/services/reports.service';
import { SsoSecurityService } from 'src/app/services/sso-security.service';
import { UserService } from 'src/app/services/user.service';
import { ApproveDialogComponent } from '../../approve-dialog/approve-dialog.component';
import { OrderDetails } from '../../model/orderdetails';
import { OrderDetailsResponse } from '../../model/orderdetailsresponse';
import { SortableColumn } from '../../model/sort/sortable-column';
import { OrderdetailsComponent } from '../orderdetails/orderdetails.component';

@Component({
    selector: 'app-order-confirmation',
    templateUrl: './order-confirmation.component.html',
    styleUrls: ['./order-confirmation.component.scss'],
    standalone: false
})
export class OrderConfirmationComponent extends OrderdetailsComponent {

  constructor(protected route: ActivatedRoute,protected reportsService:ReportsService,protected grphservice:GraphService,protected authService: MsalService,protected userservice:UserService,protected poordersummaryservice: PoOrderDataServiceService,protected router:Router,protected dialog: MatDialog,
    protected securitysso:SsoSecurityService,protected translate:TranslateService,protected session:SessionStorageService) { 
   super(route,reportsService,grphservice,authService,userservice,poordersummaryservice,router,dialog,securitysso,translate,session);

   
}



  




}

